import MicroIframe from 'micro-frontend-iframe';
import BarLoader from 'react-spinners/BarLoader';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import configureStore from 'redux/reducers';
import * as serviceWorker from 'serviceWorker';
import { Reset } from 'styled-reset';
import i18next from 'i18next';
import { I18nextProvider } from 'react-i18next';
import { firebase } from './model/firebase/firebase';
import App from './app';
import { forceReload, startSetPlatform, startSetSkills } from './redux/actions/_initializer_actions';
import { adminLogin, adminLogout } from './redux/actions/_auth_actions';
import { startShowUsers } from './redux/actions/_users_actions';
import { showCompaniesAdmin } from './redux/actions/_companies_actions';
import history from './system/router/history';
import { palette } from './system/styles/styles';
import { PlatformExeptions } from './system/utils/extras';
import common_es from './translations/es/common.json';
import common_en from './translations/en/common.json';
import '@progress/kendo-theme-default/dist/all.css';

import './index.css';
import './variables.css';
import 'react-quill/dist/quill.snow.css';
import 'react-confirm-alert/src/react-confirm-alert.css';

MicroIframe.init('UNIS-ADMIN-APP');

i18next.init({
  interpolation: { escapeValue: false },
  lng: 'es',
  resources: {
    en: {
      common: common_en,
    },
    es: {
      common: common_es,
    },
  },
});

const store = configureStore();

const Page = (
  <Provider store={store}>
    <I18nextProvider i18n={i18next}>
      <Reset />
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </I18nextProvider>
  </Provider>
);

const loading = (
  <div className="rel full">
    <div className="above-center">
      <img src="https://lapieza-unis-admin-test.s3.us-west-1.amazonaws.com/assets/animation_640_kqmntk44.gif" alt="" />
      <h4 style={{ fontSize: 24 }} className="text-center">
        Actualizando su plataforma .....
      </h4>
    </div>
    <div className="real-center">
      <BarLoader sizeUnit="px" size={750} color={palette.blue} />
    </div>
  </div>
);

ReactDOM.render(loading, document.getElementById('unis-admin-root'));

serviceWorker.unregister();

const hasRendered = false;
let listener = false;

const renderApp = () => {
  if (!hasRendered) {
    ReactDOM.render(Page, document.getElementById('unis-admin-root'));
  }
};

const callback = async (user) => {
  if (!listener) {
    const urlLocation = window.location.pathname;
    if (user) {
      ReactDOM.render(loading, document.getElementById('unis-admin-root'));
      // Comparamos que sea un admin y que sea la misma plataforma la que tiene registrada en sus claims y la de redux
      const idTokenResult = await user.getIdTokenResult();
      const isAdminUser = idTokenResult.claims.typeuser === 'adminUser';
      const isSamePlatform =
        idTokenResult.claims.segment.toUpperCase() === store.getState().platform.platformName.toUpperCase();
      const lapiezaAccess = idTokenResult.claims.segment === 'lapiezaAccess';
      if ((isAdminUser && isSamePlatform) || (isAdminUser && lapiezaAccess)) {
        store.dispatch(adminLogin(user.uid, idTokenResult.claims.typeuser));
        // await store.dispatch(showVacanciesAdmin());
        await store.dispatch(startShowUsers());
        store.dispatch(showCompaniesAdmin());
        setTimeout(() => {
          renderApp();
        }, 2000);
        if (urlLocation === '/') {
          history.push('/management/dashboard');
        }
      } else {
        store.dispatch(adminLogout());
        setTimeout(() => {
          renderApp();
        }, 2000);
      }
      // else if (isAdminUser && lapiezaAccess) {
      //   store.dispatch(adminLogin(user.uid, idTokenResult.claims.typeuser));
      //   store.dispatch(startShowApplicants());
      //   // await store.dispatch(showVacanciesAdmin());
      //   await store.dispatch(startShowUsers());
      //   store.dispatch(showCompaniesAdmin());
      //   setTimeout(() => {
      //     renderApp();
      //   }, 2000);
      //   if(urlLocation === "/") {
      //     history.push('/management/platform');
      //   }
      // }
    } else {
      store.dispatch(adminLogout());
      history.push('/login');
      setTimeout(() => {
        renderApp();
      }, 2000);
    }
    listener = true;
  }
};

const verifyUser = () => {
  firebase.auth().onAuthStateChanged(callback);
};

const loadPlatformSettings = async () => {
  // Se valida que este en entorno de producción en caso de estar en entorno de desarrollo se carga la informacion de demo

  const urlDomain = (document.referrer || window.location.href).includes('localhost')
    // ? 'https://demo-universidades.lapieza.io/'
    ?  'https://uag.lapieza.io/'
     : document.referrer || window.location.href;
  // Se extrae el subdominio para poder proceder a cargar la informacion de la plataforma, con base en el ejeplo el valor seria mondragon
  let platformName = urlDomain?.includes('lapieza.io')
    ? urlDomain.substring(urlDomain.lastIndexOf('//') + 2, urlDomain.lastIndexOf('.l'))
    : urlDomain.substring(urlDomain.lastIndexOf('//') + 2);
  const existSlash = platformName.indexOf('/');
  platformName = platformName.substring(0, existSlash === -1 ? platformName.length : existSlash);
  //  urlDomain;
  // Algunas plataformas solicitaron un cambio en el nombre de dominios la funcion PlatformExeptions(exeption) se encarga de manipular esas exepciones
  const platform = PlatformExeptions(platformName);
  await forceReload();
  await store.dispatch(startSetPlatform(platform));
  // await store.dispatch(removeOldVacancies());
  await store.dispatch(startSetSkills());
  // Se cambiara de lugar ya que no se utiliza en el dashboar
  // await store.dispatch(startShowVacancies());
  verifyUser();
};

loadPlatformSettings().then();
